<template>
	<Dropdown>
		<!-- trigger element -->
		<template #trigger>
			<span class="menu-button">
				<FontAwesomeIcon icon="ellipsis-v" />
			</span>
		</template>

		<!-- contents display in dropdown -->
		<DropdownContent class="d-flex flex-column">
			<div class="menu-item" @click="onSnoozeChallengeClick()">
				<FontAwesomeIcon icon="eye-slash" class="mr-2" />
				<span>{{ t.dashboardSnoozeChallengeButton }}</span>
			</div>

			<!-- Display owner information if exists -->
			<div v-if="item.challenge_owner_name" class="challenge-dropdown-menu-owner">
				<div>
					{{ t.challengeMenuOrganizer }} {{ item.challenge_owner_name }}
				</div>
				<div v-if="item.challenge_owner_email">
					{{ t.challengeMenuMessageOrganizer }} <a :href="'mailto:' + item.challenge_owner_email">{{ item.challenge_owner_email }}</a>
				</div>
			</div>
		</DropdownContent>
	</Dropdown>
</template>

<script setup>
import { computed } from 'vue';
import { Dropdown, DropdownContent } from 'v-dropdown';
import { useStore } from '@/js/stores/index';
import { toastSuccess } from '@/js/includes/toast';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useChallenges } from '@/js/stores/challenges';

// Stores
const store = useStore()
const { snoozeChallenge } = useChallenges()

// Props
const props = defineProps({
	item: {
		type: Object,
		required: true
	}
})

// Computeds
const t = computed(() => store.translations)

// Methods
async function onSnoozeChallengeClick(){
	await snoozeChallenge(props.item.id)
	toastSuccess(t.value.dashboardSnoozedChallengeAlertText)
}
</script>